import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { required } from "../../../utils/formValidators";
import { renderCheckboxField } from "../../../utils/renderField";
import { debitAndCreditDisclosure, achSecondDisclosure } from "../../../utils/content";
import Show from "../../../utils/show.component";
import {
  StandardDebitDisclosure,
  StandardAchDisclosure,
} from "../../authenticated-payments/misc/disclosures";

export class LoanReviewFormComponent extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(e) {
    this.props.submitForm(this.props.form);
  }

  render() {
    const { submitting, handleSubmit, paymentType } = this.props;

    return (
      <form onSubmit={handleSubmit(this.submitForm)} data-e2e-id="reviewForm">
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Show condition={paymentType === "debit"}>{StandardDebitDisclosure(true)}</Show>
              <Show condition={paymentType === "ach"}>{StandardAchDisclosure(true)}</Show>
              <Show condition={paymentType === "Appraisal"}>
                <Field
                  label={debitAndCreditDisclosure}
                  name="paymentAuthorization"
                  type="checkbox"
                  id="paymentAuthorization"
                  component={renderCheckboxField}
                  validate={[required]}
                />
              </Show>
            </div>
          </div>
        </div>
        {/* hide payment reminder for now
        <Show condition={false}>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <Field
                  label="Text me when my next due date is approaching"
                  name="paymentReminderAuthorization"
                  type="checkbox"
                  id="paymentReminderAuthorization"
                  component={renderCheckboxField}
                />
              </div>
            </div>
          </div>
        </Show>
        {formValues.values ? (
          <Show condition={formValues.values.paymentReminderAuthorization === true}>
            <div className="row">
              <div className="col-12">
                <div className="form-group" style={{ marginTop: "0px" }}>
                  <Field
                    component={renderField}
                    label="Enter your phone number and we'll send you a text message 5 days before your
                    payment is due.*"
                    name="paymentReminderPhoneNumber"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </Show>
        ) : null}
        */}
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <button
                disabled={submitting}
                className="button primary full"
                type="submit"
                data-e2e-id="reviewSubmitButton"
              >
                {this.props.payoffCheck.PaymentTypeChangedToPayoff === true
                  ? "Pay Off My Loan"
                  : "Submit Payment"}
              </button>
            </div>
          </div>
        </div>
        {/* {formValues.values ? (
          <Show condition={formValues.values.paymentReminderAuthorization === true}>
            <div className="disclosure">* Message and data rates may apply</div>
          </Show>
        ) : null}  */}
      </form>
    );
  }
}

//Connect to Redux store
const LoanReviewForm = reduxForm({
  form: "LoanReview",
  destroyOnUnmount: false,
})(LoanReviewFormComponent);

export default LoanReviewForm;



// WEBPACK FOOTER //
// ./src/components/forms/loan-review/loan-review-form.component.js